import { MarketConfigType } from "../../typings";

export const pickLiveOrPreliveId = (marketConfig: MarketConfigType, isLive: boolean): string => {
    return isLive ? marketConfig.idLive : marketConfig.idPreLive;
}